import { createAsyncThunk, createSlice, } from '@reduxjs/toolkit'
import { getMyFutureBookings } from '@features/meeting-rooms/MeetingRoomsService';
import { AppState } from '@app/store/state/app.state';
import { groupBy } from '@shared/utils/ArrayUtils';

export interface MeetingRoomState {
  groupedBookings: any;
  loading: boolean;
}

export const initialMeetingRoomState: MeetingRoomState = {
  groupedBookings: {},
  loading: false,
}

export const loadBookings: any = createAsyncThunk(
  'meetingRoom/loadBookings',
  async (params: {}, thunkAPI) => {
    const bookings = await getMyFutureBookings();
    const groupedBookings = groupBy(bookings, 'dateString');

    return {
      groupedBookings: groupedBookings,
    }
  }
)

const meetingRoomSlice = createSlice({
  name: 'meetingRoom',
  initialState: initialMeetingRoomState,
  reducers: {
    reset: () => initialMeetingRoomState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadBookings.pending, (state) => ({...state, loading: true,}))
      .addCase(loadBookings.rejected, (state) => ({...state, loading: false,}))
      .addCase(loadBookings.fulfilled, (state, action) => ({ ...state, groupedBookings: action.payload.groupedBookings, loading: false, }));
  }
})

export default meetingRoomSlice.reducer;


// Selectors
export const selectUsersGroupedBookings = (state: AppState) => state.meetingRoom.groupedBookings;
export const selectIsMeetingRoomBookingsLoading = (state: AppState) => state.meetingRoom.loading;
